import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose();

const button = enhance(
  ({ classes, disabled, shopId, titleStatus, onClickAction }) => {
    const updateChange = () => {
      onClickAction(shopId);
    };
    return (
      <div>
        <Button disabled={disabled} color="primary" onClick={updateChange}>
          <VisibilityOffIcon className={classes.leftIcon} />
          {titleStatus}
        </Button>
      </div>
    );
  }
);

export default withStyles(styles)(button);
